/*
 * View for a single substitution Group
 */

define([
  "marionette",
  "modules/substitutions/substitutionGroup/substitutionGroupInfo/template/substitutionGroupInfoTemplate.html",
], function (Marionette, SubstitutionGroupInfoTemplate) {
  var SubstitutionGroupInfoView = {};

  SubstitutionGroupInfoView.substitutionGroupInfoView = Marionette.ItemView.extend({
    template: SubstitutionGroupInfoTemplate,
    nameError: function (errorMessage) {
      this.$el
        .find("#substNameText")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    textboxes: {
      "#substNameText": {
        enableSelector: "#substName",
        modelAttribute: "name",
        placeholder: "substitutions.group.name",
        textArea: false,
      },
      "#substDescText": {
        enableSelector: "#substDesc",
        modelAttribute: "description",
        placeholder: "substitutions.group.description",
        textArea: false,
      },
    },
    triggers: {
      "click #deleteGroup": "delete:group",
    },
  });

  return SubstitutionGroupInfoView;
});
